import {
  apiRequest,
  skp3kDetail,
} from "../../../../../services/adapters/kepegawaian/skp3kService";

class DetailRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      skp3kDetail,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
